import { render, staticRenderFns } from "./WorkCalendarSidebar.vue?vue&type=template&id=3ef1cfee&scoped=true"
import script from "./WorkCalendarSidebar.vue?vue&type=script&lang=js"
export * from "./WorkCalendarSidebar.vue?vue&type=script&lang=js"
import style0 from "./WorkCalendarSidebar.vue?vue&type=style&index=0&id=3ef1cfee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef1cfee",
  null
  
)

export default component.exports